import { formatPatientName } from '../../../lib/patientName'

export default function RelatedPart({activeCase, classes}) {
    return <>
        {activeCase.related_patients && activeCase.related_patients.length > 0 && <>
            <h4>Treating Together</h4>
            <div className={classes.background_container}>
                {activeCase.related_patients.map(item => (
                    <div key={item.id} className={classes.row}>{formatPatientName(item)}</div>
                ))}
            </div>                                
        </>}
    </>
}